<template>
  <div class="content-panel">
    <div class="bcg-loading" v-if="loading">
      <v-progress-circular
        class="loading-spinner"
        indeterminate
      ></v-progress-circular>
    </div>
    <div v-else :key="`mortgage-${idOfMortgage}`">
      <progress-bar-hypoteky @switch-to="switchComponent($event)"/>
      <component
        :is="component"
        :mortgage="mortgage"
        :applicant="applicant"
        :co-applicant="coApplicant"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ApplicationChoice from "./KartyHypotekyDetailStages/ApplicationChoice";
import ApplicationSign from "./KartyHypotekyDetailStages/ApplicationSign";
import ApplicationApproval from "./KartyHypotekyDetailStages/ApplicationApproval";
import ApplicationSummary from "./KartyHypotekyDetailStages/ApplicationSummary";
import DocumentCompletion from "./KartyHypotekyDetailStages/DocumentCompletion";
import ProgressBarHypoteky from "../../../components/broker/KartaHypoteky/KartaHypotekyDetail/ProgressBarHypoteky";

export default {
  name: "KartaHypoteky",
  components: {
    ApplicationChoice,
    ApplicationSign,
    DocumentCompletion,
    ApplicationApproval,
    ApplicationSummary,
    ProgressBarHypoteky
  },
  async created () {
    await this.loadMortgage(this.$route.params.hypoteka);
  },
  computed: {
    ...mapGetters({
      mortgageGetter: "mortgageDetailState/getMortgage",
      applicantGetter: "mortgageDetailState/getApplicant",
      coApplicantGetter: "mortgageDetailState/getCoApplicant",
    }),
  },
  watch: {
    "$route.params.hypoteka" (mortgageId) {
      if (Number(mortgageId) === this.idOfMortgage) return;
      this.loadMortgage(mortgageId);
    },
    mortgageGetter (newMortgage) {
      this.mortgage = newMortgage;
    },
    applicantGetter (newApplicant) {
      this.applicant = newApplicant;
    },
    coApplicantGetter (newCoApplicant) {
      this.coApplicant = newCoApplicant;
    },
  },
  beforeDestroy () {
    this.loadSequence += 1;
    this.stopMortgageFetch();
    this.$store.commit("mortgageDetailState/nullState");
    this.$store.commit("mortgageDetailCloud/initCloud");
  },
  methods: {
    async loadMortgage (rawMortgageId) {
      const mortgageId = Number(rawMortgageId);
      if (!Number.isInteger(mortgageId)) return;
      const loadSequence = ++this.loadSequence;
      const isSwitch = this.idOfMortgage !== null && this.idOfMortgage !== mortgageId;
      this.loading = true;
      this.stopMortgageFetch();
      if (isSwitch) {
        this.$store.commit("mortgageDetailState/nullState");
        this.$store.commit("mortgageDetailCloud/initCloud");
      }
      this.idOfMortgage = mortgageId;
      this.component = null;

      try {
        await this.$store.dispatch("mortgageDetailState/initializeMortgageDetailInfo", mortgageId);
        if (loadSequence !== this.loadSequence) return;
        this.mortgage = this.mortgageGetter;
        this.applicant = this.applicantGetter;
        this.coApplicant = this.coApplicantGetter;
        this.mortgageFetch();
      } catch (error) {
        if (loadSequence !== this.loadSequence) return;
        this.$store.commit("appState/setSuccessMessage", {
          text: "Hypotéku sa nepodarilo načítať",
          type: "error",
        });
        console.error("Could not load mortgage", mortgageId, error);
      } finally {
        if (loadSequence === this.loadSequence) this.loading = false;
      }
    },
    switchComponent(target) {
      this.component = target;
    },
    mortgageFetch () {
      this.stopMortgageFetch();
      this.mortgageUpdate = setInterval(() => {
        this.$store.dispatch("mortgageDetailState/fetchMortgage");
      }, 30000);
      this.propertiesUpdate = setInterval(() => {
        this.$store.dispatch("mortgageDetailState/fetchProperties");
      }, 30000)
    },
    stopMortgageFetch () {
      clearInterval(this.mortgageUpdate);
      clearInterval(this.propertiesUpdate);
      this.mortgageUpdate = null;
      this.propertiesUpdate = null;
    },
  },
  data: () => ({
    idOfMortgage: null,
    loading: true,
    component: null,
    mortgage: null,
    applicant: null,
    coApplicant: null,
    mortgageUpdate: null,
    propertiesUpdate: null,
    loadSequence: 0,
  }),
};
</script>

<style scoped lang="scss">
.bcg-loading {
  z-index: 9999;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading-spinner-wrapper {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.wrapper {
  position: relative;
}
</style>
